import { store } from "@lib/stores";
import * as Api from "@modules/api";
import { db } from "@modules/local/db";
import { errorHandler } from "@utils/helpers/errorHandler";

export const getMyPlansAsync = async (): Promise<
  Api.Server.CustomerPlanOutput[] | undefined
> => {
  return errorHandler(async () => {
    const client = new Api.Server.Server_Plans_Client(undefined, Api.apiClient);

    const response = await client.plans_customer_get_V1();

    if (response.success && response.data) {
      await db.readerPlans.put({
        userId: store.getState().auth.user.id ?? "",
        plans: response.data,
      });

      return response.data;
    }

    if (response.success && !response.data) {
      throw new Error("No Data");
    }

    throw response.errors;
  });
};

export const PlanActions = {
  getMyPlansAsync,
};
